export enum SIZES {
  MAX_CHARS_TO_SHOW_PREDICT = 3,
  NO_CHARS = 0
}
